<div class="admin-dashboard" [class.paddingLeft]="isSidebarExpanded">
  <!-- Header Section -->
  <div class="dashboard-header">

    <div class="header-content">
      <h1 class="dashboard-title">Dashboard
        @if(selectedAgent){
        (# {{this.selectedAgent.firstName + ' ' + this.selectedAgent.lastName}})
        }
      </h1>
      <p class="dashboard-subtitle">Manage and monitor your admin's performance</p>
    </div>

    <div class="header-actions">

      <div class="agent-dropdown">

        <button class="dropdown-toggle" (click)="$event.stopPropagation(); toggleAgentDropdown()">
          <div class="selected-agent">
            <div class="agent-avatar-small" [style.background-color]="getSelectedAgentColor()">
              <span>{{ selectedAgent ? (selectedAgent.firstName | initials : selectedAgent.lastName ) : 'A' }}</span>
            </div>
            <span class="agent-name-text">{{ getSelectedAgentName() }}</span>
          </div>
          <svg class="dropdown-arrow" [class.rotated]="isAgentDropdownOpen" width="16" height="16" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2">
            <path d="M6 9l6 6 6-6" />
          </svg>
        </button>

        <div class="dropdown-menu" [class.open]="isAgentDropdownOpen"
          [style.display]="isAgentDropdownOpen ? 'block' : 'none'" [style.width.px]="320" aria-haspopup="listbox"
          [attr.aria-expanded]="isAgentDropdownOpen" (click)="$event.stopPropagation()">

          <!-- Search input -->
          <div class="dropdown-search">
            <input type="text" [(ngModel)]="agentSearchText" placeholder="Search agent..."
              class="dropdown-search-input" />
          </div>

          <div class="dropdown-item consolidated" [class.selected]="!selectedAgent" role="option"
            [attr.aria-selected]="!selectedAgent" (click)="selectAgentFromDropdown(null)">
            <div class="agent-avatar-small consolidated-avatar">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </div>
            <span class="fs-14">All Agents</span>
          </div>

          <ng-container *ngIf="agentList?.length; else noAgentsTpl">
            <div class="dropdown-item" *ngFor="let agent of getFilteredAdmins(); let i=index; trackBy: trackByAgentId"
              [class.selected]="selectedAgent?.id === agent.id" role="option"
              [attr.aria-selected]="selectedAgent?.id === agent.id" (click)="selectAgentFromDropdown(agent)">
              <div class="agent-avatar-small" [style.background-color]="getColor(i)">
                <span>{{ agent.firstName | initials : agent.lastName }}</span>
              </div>
              <div class="agent-texts">
                <span class="agent-name">{{ agent.firstName }} {{ agent.lastName }}</span>
                <span class="agent-status-badge" [class]="getAgentActiveClass(agent)">
                  {{ getAgentActiveLabel(agent) }}
                </span>
              </div>
            </div>
          </ng-container>

          <ng-template #noAgentsTpl>
            <div class="dropdown-empty">No admins available</div>
          </ng-template>

        </div>
      </div>

    </div>
  </div>

  <!-- Main Dashboard Content -->
  <div class="dashboard-content">

    <!-- Right Side Content Area -->
    <div class="dashboard-right-content">
      <!-- Top Section: Status Cards and Chart -->
      <div class="dashboard-top-section">
        <!-- Status Cards -->
        <div class="status-cards">
          <div class="status-card animate-slide-up" *ngFor="let card of cardConfigs"
            [ngStyle]="{'--card-bg-color': card.bg, '--card-icon-color': card.iconBg}">
            <div class="card-icon">
              <ng-container [ngSwitch]="card.icon">
                <!-- info -->
                <svg *ngSwitchCase="'info'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                  viewBox="0 0 24 24">
                  <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                    stroke-miterlimit="10" stroke-width="2"
                    d="M12 8h.008M12 16v-5m10 1c0 5.523-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2s10 4.477 10 10" />
                </svg>

                <!-- inbox -->
                <svg *ngSwitchCase="'inbox'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                  viewBox="0 0 24 24">
                  <path fill="currentColor"
                    d="M12.5 7a.5.5 0 0 0-1 0v4.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L12.5 11.793z"
                    stroke-width="0.3" stroke="currentColor" />
                  <path fill="currentColor"
                    d="M3.692 10.257a5.6 5.6 0 0 0-.192 1.88c0 .853.002 2.209.041 3.45c.02.653.052 1.282.1 1.793c.023.254.051.487.086.681c.032.18.078.377.154.528a3.5 3.5 0 0 0 1.53 1.53c.403.205.847.295 1.378.338c.52.043 1.167.043 1.989.043h6.444c.821 0 1.469 0 1.99-.043c.53-.043.974-.133 1.377-.338a3.5 3.5 0 0 0 1.53-1.53a2 2 0 0 0 .154-.528c.035-.194.063-.427.087-.681c.047-.51.078-1.14.099-1.794c.039-1.245.04-2.607.041-3.46a5.6 5.6 0 0 0-.192-1.869l-.833-2.913l-.055-.193c-.35-1.24-.775-2.744-2.36-3.391c-.637-.26-1.379-.26-2.563-.26H9.502c-1.184 0-1.925 0-2.563.26c-1.585.647-2.01 2.15-2.36 3.39l-.055.194zM9.62 4.5h4.759c1.343 0 1.87.009 2.303.186c1.125.46 1.424 1.505 1.817 2.881l.847 2.965c.132.463.183.971.16 1.468H19.5v.095q-.005.074-.012.147a2.5 2.5 0 0 1-2.246 2.246a6 6 0 0 1-.62.025h-.04c-.187 0-.35 0-.5.03a1.5 1.5 0 0 0-.997.719a2.4 2.4 0 0 0-.183.45l-.012.036c-.125.373-.238.528-.346.607s-.29.145-.697.145h-3.694c-.394 0-.576-.059-.686-.136c-.108-.076-.229-.23-.358-.616l-.011-.035a2.4 2.4 0 0 0-.183-.451a1.5 1.5 0 0 0-.997-.718a2.5 2.5 0 0 0-.5-.03h-.04q-.323.002-.62-.026A2.5 2.5 0 0 1 4.5 12.105V12h-.006a4.6 4.6 0 0 1 .16-1.468L5.5 7.567c.393-1.376.692-2.422 1.817-2.881c.433-.177.96-.186 2.303-.186M4.54 15.555a96 96 0 0 1-.025-1.09a3.5 3.5 0 0 0 2.146 1.018c.243.024.485.03.718.03c.249 0 .3.003.338.01a.5.5 0 0 1 .332.24c.02.033.037.077.112.301c.155.465.364.86.73 1.117c.363.256.798.319 1.262.319h3.694c.49 0 .93-.074 1.29-.34c.358-.263.555-.656.702-1.096c.074-.224.091-.268.111-.301a.5.5 0 0 1 .332-.24c.038-.007.09-.01.339-.01c.233 0 .474-.006.718-.03a3.5 3.5 0 0 0 2.146-1.018c-.006.363-.014.731-.026 1.09a29 29 0 0 1-.095 1.732c-.022.24-.047.443-.075.598q-.021.117-.04.185l-.021.065a2.5 2.5 0 0 1-1.093 1.092c-.239.122-.536.195-1.005.234c-.476.039-1.082.039-1.93.039H8.8c-.848 0-1.455 0-1.93-.04c-.469-.038-.766-.11-1.005-.233a2.5 2.5 0 0 1-1.093-1.092q-.002-.002-.02-.065a2 2 0 0 1-.04-.185a8 8 0 0 1-.076-.598a30 30 0 0 1-.095-1.732"
                    stroke-width="0.3" stroke="currentColor" />
                </svg>
                <!-- pie -->
                <svg *ngSwitchCase="'pie'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2">
                  <path d="M21 12a9 9 0 1 1-9-9v9z" />
                  <path d="M12 3a9 9 0 0 1 9 9h-9z" />
                </svg>
                <!-- spinner/progress -->
                <svg *ngSwitchCase="'spinner'" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2">
                  <path
                    d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
                </svg>
                <!-- check -->
                <svg *ngSwitchCase="'check'" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <!-- document -->
                <svg *ngSwitchCase="'document'" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                </svg>
                <!-- send -->
                <svg *ngSwitchCase="'send'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2">
                  <line x1="22" y1="2" x2="11" y2="13" />
                  <polygon points="22 2 15 22 11 13 2 9 22 2" />
                </svg>
                <!-- clock -->
                <svg *ngSwitchCase="'clock'" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
                <!-- x/declined -->
                <svg *ngSwitchCase="'x'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </ng-container>
            </div>
            <div class="card-content" (mouseenter)="card.hoverTrigger$.next()">
              <h3 class="card-value">{{ getCardCount(card.key) | countUp:card.hoverTrigger$:1000 | async }}</h3>
              <p class="card-label">{{ card.label }}</p>
            </div>
          </div>
        </div>

        <!-- Agent Performance + Recent Activity in one row -->
        <div class="charts-activity-row">

          <div class="chart-section animate-slide-right">
            <div class="chart-header">
              <h2>Overall Performance</h2>

              <!-- Time Range Controls -->
              <div class="chart-controls range-controls">
                <button class="chart-btn" [class.active]="timeRange === 'weekly'"
                  (click)="setTimeRange('weekly')">Weekly</button>
                <button class="chart-btn" [class.active]="timeRange === 'monthly'"
                  (click)="setTimeRange('monthly')">Monthly</button>
                <button class="chart-btn" [class.active]="timeRange === 'yearly'"
                  (click)="setTimeRange('yearly')">Yearly</button>
              </div>
            </div>

            <div class="chart-container">
              <canvas baseChart [data]="lineChartData" [options]="lineChartOptions" [type]="'line'">
              </canvas>
            </div>

          </div>

          <div class="recent-activity w-100">
            <h3>Recent Activity</h3>
            <div class="activity-list">

              <!-- Loader -->
              <div *ngIf="recentActivityLoading" class="loader-pro">
                <app-loader></app-loader>
              </div>

              <!-- No activity -->
              <div *ngIf="!recentActivityLoading && recentActivity.length === 0">
                <app-no-data-found></app-no-data-found>
              </div>

              <!-- Activity items -->
              <div *ngIf="!recentActivityLoading && recentActivity.length > 0">
                <div class="activity-item animate-pop-in" *ngFor="let activity of recentActivity">
                  <div class="activity-icon" [ngClass]="activity.type">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path
                        d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
                    </svg>
                  </div>

                  <div class="activity-content">
                    <p class="activity-text">{{ activity.text }}</p>
                    <span class="activity-time">{{ activity.createdAt | timeAgo }}</span>
                  </div>
    
                </div>
              </div>

            </div>
          </div>


        </div>
      </div>
    </div>
  </div>